import COS from "cos-js-sdk-v5";
import { FEDERATIONTOKENBYBUCKET } from "@/http/api";



const TencentCOS = function() {
    this.savekey = ""
    this.cos = ""
    this.cosConfig = {
        prefix: "AttachFiles/",
        Bucket: 'forclass-1259419845',
        Region: 'ap-beijing',
        Cdn: 'https://fordata.forclass.net'
    }
}
TencentCOS.prototype = {
    init: function(option, that){
        /**
         * option
         * => userid 必传
         * 
         */
        this.savekey = this.cosConfig.prefix + option.userid + "/";
        this.maxSize = option.maxSize || 200;
        this.cos = new COS({
            getAuthorization: (options, callback)=>{
                var param = {
                    bucket: this.cosConfig.Bucket
                }
                // FEDERATIONTOKENBYBUCKET(param).then(info=>{
                    // console.log('签名',info)
                FEDERATIONTOKENBYBUCKET(param).then((config)=>{
                    let info = config.data.data
                    if (info) {
                        var credentials = info.Credentials;
                        callback({
                            XCosSecurityToken: credentials.Token,
                            Authorization: COS.getAuthorization({
                                SecretId: credentials.TmpSecretId,
                                SecretKey: credentials.TmpSecretKey,
                                Method: options.Method,
                                Pathname: options.Pathname,
                            })
                        });
                    } else {
                        console.error('获取签名出错', xhr.responseText);
                        that.config.fail('网络繁忙请稍后再试！');
                    }
                })
            },
            UploadCheckContentMd5: true // 是否检测 md5
        });
    },
    // 转化为CDN地址
    replaceUrl2COSCDN: function(url) {
        if (url) {
            url = url.replace(this.cosConfig.Bucket + ".cos." + this.cosConfig.Region + ".myqcloud.com", this.cosConfig.Cdn);
        }
        return url;
    },
    getSaveKey: function(savekey, filename) {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        var ext = filename.slice(filename.lastIndexOf('.'));
        var diskFileName = (year + "_" + month + "_" + day + "_" + date.getTime() + ext);
        var save_key = (savekey + diskFileName);
        return save_key;
    },
    putObject: function(options) {
        // console.log('options',options)
        var file = options.file;
        var fileName = file.name;
        if (file) {
            var fileSize = 0;
            if (file.size > 1024 * 1024) {
                fileSize = (Math.round(file.size * 100 / (1024 * 1024)) / 100).toString() + 'MB';
                if (parseFloat(fileSize) > this.maxSize) {
                    
                    return;
                }
            } else if (file.size == 0) {

                return
            }
            var save_key = this.getSaveKey(this.savekey, fileName);
            var uploadFileName = encodeURI(fileName.replace(/[(\ )(\~)(\!)(\@)(\#)(\$)(\%)(\^)(\&)(\*)(\()(\))(\-)(\_)(\+)(\=)(\[)(\])(\{)(\})(\|)(\\)(\;)(\:)(\,)(\/)(\<)(\>)(\?)(\)(\')(\")]+/g, "_"));
            this.cos.putObject({
                Bucket: this.cosConfig.Bucket,
                Region: this.cosConfig.Region,
                Key: save_key,
                Body: file,
                SliceSize: 1024 * 1024 * 5, // 大于5mb才进行分块上传
                Headers: {
                    'content-disposition': "attachment;filename=" + uploadFileName + ";filename*=UTF-8''" + uploadFileName
                },
                onTaskReady: function (tid) {
                    options.onTaskReady && options.onTaskReady(tid)
                },
                onTaskStart: function (info) {
                    options.onTaskStart && options.onTaskStart(info)
                },
                onProgress: function (info) {
                    options.onProgress && options.onProgress(info)
                }
            }, function(err, data) {
                if(err){
                    options.onUploadFailed && options.onUploadFailed(err)
                }
                if(data){
                    options.onUploadSuccess && options.onUploadSuccess(data, save_key)
                }
            });
        }
    },
    deleteObject: function() {
        if(tencentcos.currFileKey && tencentcos.currFileKey != ""){
            cos.deleteObject({
                Bucket: cosConfig.Bucket,
                Region: cosConfig.Region,
                Key: tencentcos.currFileKey
            }, function(err, data){
                console.log(err, data)
                if(err){
                    console.log("删除云端文件异常")
                }
                if(data){
                    tencentcos.lastFileKey = null;
                }
            });
        }
    }
}

export { TencentCOS }